import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'licensing-component',
    template: '<div></div>',
    styles: [],

})
export class LicensingComponent implements OnInit {

    constructor(private router: Router) {
    }


    ngOnInit() {
        switch (this.router.url) {
            case '/tos':
                window.location.href = '/licensing/tos.txt';
                break;
            case '/eula':
                window.location.href = '/licensing/eula.txt';
                break;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/licensing/licensing.component.ts